import api from './api';

const buildHeaders = () => {
  const token = localStorage.getItem('access_token');
  const headers = {
    'Content-Type': 'application/json',
    client_id: process.env.REACT_APP_CLIENT_ID,
  };
  if (token) {
    headers.access_token = token;
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
};

export async function updateCommitment(commitmentId, payload) {
  const headers = buildHeaders();
  try {
    return await api.patch(`rating/v1/commitment/${commitmentId}`, payload, { headers });
  } catch (err) {
    if (err && err.response && err.response.status === 404) {
      try {
        const possibleSfId = commitmentId;
        const storeId = localStorage.getItem('storeId') || undefined;
        const res = await getAppointmentList({ storeId });
        const data = res && res.data ? res.data : res;
        const items = data && data.appointments ? data.appointments : Array.isArray(data) ? data : [];
        const found = (items || []).find(it => (
          it.commitment_id_sf === possibleSfId || it.commitmentId === possibleSfId || it.Id === possibleSfId || it.id === possibleSfId
        ));
        const patchId = found && (found.id || found.Id);
        if (patchId) {
          console.debug(`updateCommitment: retrying PATCH with resolved id ${patchId} for original id ${commitmentId}`);
          return await api.patch(`rating/v1/commitment/${patchId}`, payload, { headers });
        }
      } catch (e) {
        console.debug('updateCommitment: fallback lookup failed', e);
      }
    }
    throw err;
  }
}

export async function getCommitment(commitmentId) {
  const headers = buildHeaders();
  return api.get(`rating/v1/commitment/${commitmentId}`, { headers });
}

export async function getAppointmentDetails(appointmentId) {
  const headers = buildHeaders();
  return api.get(`rating/v1/commitment/appointment/details/${appointmentId}`, { headers });
}

export async function getAppointmentList({ storeId, startDate, endDate } = {}) {
  const headers = buildHeaders();
  const params = `?storeId=${storeId || localStorage.getItem('storeId')}&startDate=${startDate || ''}&endDate=${endDate || ''}`;
  return api.get(`rating/v1/commitment/appointment/list${params}`, { headers });
}

export async function getAppointmentDetailsById(appointmentId) {
  const headers = buildHeaders();
  const res = await api.get(`rating/v1/commitment/appointment/details/${appointmentId}`, { headers });
  const data = res && res.data ? res.data : res;
  if (data && Array.isArray(data.appointments) && data.appointments.length > 0) {
    const found = data.appointments.find(a => a.Id === appointmentId) || data.appointments[0];
    return { data: found };
  }
  return { data };
}

export async function postIndecxAnswer(payload) {
  const headers = buildHeaders();
  return api.post('rating/v1/commitment/indecx/answer', payload, { headers });
}

export async function confirmCommitment(commitmentId, extra = {}) {
  const payload = {
    user_id: localStorage.getItem('userId') || null,
    confirm: true,
    accordance: true,
    ...extra,
  };
  return updateCommitment(commitmentId, payload);
}

export async function denyCommitment(commitmentId, extra = {}) {
  const payload = {
    user_id: localStorage.getItem('userId') || null,
    confirm: false,
    finished: true,
    ...extra,
  };
  return updateCommitment(commitmentId, payload);
}

export async function closeCommitment(commitmentId) {
  const payload = {
    user_id: localStorage.getItem('userId') || null,
    close: true,
  };
  return updateCommitment(commitmentId, payload);
}

export default {
  updateCommitment,
  confirmCommitment,
  denyCommitment,
  closeCommitment,
  getAppointmentList,
  getAppointmentDetails,
  getAppointmentDetailsById,
  postIndecxAnswer,
};
